export const ALL_ACCESS = "all-access";
export const ALL_DELETE = "all-delete";
export const CAARYA_DIRECTOR = "caarya-director";
export const PMO = "pmo";
export const CPO = "cpo";
export const VMO = "vmo";
export const HR_ADMIN = "hr-admin";
export const HR_COORDINATOR = "hr-coordinator";
export const PROJECT_MANAGER = "project-manager";
export const PROJECT_MEMBER = "project-member";
export const PROJECT_OWNER = "project-owner";
export const NODE_MANAGER = "node-manager";
export const NODE_MEMBER = "node-coordinator";
export const RECRUITER = "recruiter";
export const MARKETING_MANAGER = "marketing-manager";
export const GENERAL_ACCESS = "general-access";
export const MEDIA_MANAGER = "media-manager";
export const MEDIA_COORDINATOR = "media-coordinator";
export const STARGAZER = "stargazer";
